import { createSelector } from '@reduxjs/toolkit'
import { Slice, PostSlice, PostElement } from './types'

export const getPostObject = (post: PostSlice): PostElement | undefined => {
  if (!post) {
    return
  }

  const { isFetching, isSuccess, isFailure, payload } = post
  const isFirstLoad = !payload

  return {
    isFirstLoad,
    isFetching,
    isSuccess,
    isFailure,
    data: payload
  }
}

export const getPost = (slug: string) => createSelector(
  (state: any) => state.blog.post[slug],
  (post: PostSlice) => getPostObject(post)
)

export const getAllPosts = createSelector(
  (state: any) => state.blog.post,
  (post: Slice) => {
    return Object.keys(post).map(slug => {
      return getPostObject(post[slug])
    })
  }
)

export const getPostBySlugs = (slugs: string[] = []) => createSelector(
  (state: any) => state.blog.post,
  (post: Slice) => {
    return slugs.map(slug => {
      return getPostObject(post[slug])
    })
  }
)
